import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "research-item" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["item-title", {pointer: $props.item.description}]),
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggle && $options.toggle(...args)))
    }, [
      ($props.current)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: "arrow-right",
            size: "1.2rem",
            stroke: "var(--brand-700)"
          }))
        : (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            icon: "lightbulb-02",
            size: "1.2rem",
            stroke: "var(--brand-500)"
          })),
      _createVNode(_component_Ellipsis, { class: "title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.item.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      ($props.item.description)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 2,
            icon: $data.open ? 'chevron-down' : 'chevron-right',
            size: "1.2rem",
            stroke: "var(--brand-500)"
          }, null, 8 /* PROPS */, ["icon"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($props.item.description)
      ? (_openBlock(), _createBlock(_component_Collapse, {
          key: 0,
          open: $data.open,
          onAfterEnter: _cache[1] || (_cache[1] = $event => (_ctx.$emit('expanded', _ctx.$el)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MdContent, {
              class: "description",
              markdown: $props.item.description
            }, null, 8 /* PROPS */, ["markdown"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open"]))
      : _createCommentVNode("v-if", true)
  ]))
}